import {MenuAppBar} from "./components/MenuAppBar";
import Alerts from "./components/Alerts";
import {AuthProvider} from "./context/AuthProvider";
import UpdateNotifier from "./components/UpdateNotifier";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import EventBus from "./services/event-bus.js";
import {SnackbarProvider} from "notistack";
import {ConfirmModalProvider} from "./context/ConfirmModalProvider";
import SentryContextProvider from "./context/SentryContextProvider";
import AppRoutes from "./routes/AppRoutes";
import useWakeLock from './hooks/useWakeLock';
import {useEffect} from "react";
import {BottomNavbar} from "./components/BottomNavbar.jsx";
import {useLocation} from "react-router";

window.EventBus = EventBus;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => failureCount < 2 && !error?.response,
            retryDelay: 300,
        },
    },
});

function App() {
    const { requestWakeLock, releaseWakeLock } = useWakeLock();
    const location = useLocation();

    const hideBottomNavbarRoutes = ['/login'];
    const shouldHideBottomNavbar = hideBottomNavbarRoutes.includes(location.pathname);

    useEffect(() => {
        requestWakeLock();
        // Rilascia il lock al termine o quando il componente viene smontato
        return () => {
            releaseWakeLock();
        };
    }, [requestWakeLock, releaseWakeLock]);

    return (
        <QueryClientProvider client={queryClient}>
            <SnackbarProvider
                dense
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                disableWindowBlurListener
            >
                <div className="App" style={{paddingTop: "40px", paddingBottom: "60px"}}>
                    <ConfirmModalProvider>
                        <AuthProvider>
                            <SentryContextProvider>
                                <MenuAppBar/>
                                <AppRoutes/>
                                {!shouldHideBottomNavbar && <BottomNavbar/>}
                                <UpdateNotifier/>
                            </SentryContextProvider>
                        </AuthProvider>
                    </ConfirmModalProvider>
                    <Alerts/>
                </div>
            </SnackbarProvider>
        </QueryClientProvider>
    );
}

export default App;